import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Container, Header } from 'semantic-ui-react';

import { clienteApi } from 'src/api';
import { Contexto } from 'src/contexto';
import FormularioCompleto from '../../comun/FormularioCompleto';
import ModalError from '../../comun/ModalError';
import { MatriculaState } from '../../comun/tipos';
import { EstadoVerificacion } from '../../Supervision/ProcesoDeMatricula';
import PanelEstadoDeSupervision from './PanelEstadoDeSupervision';

type Props = RouteComponentProps<{ id: string }>;

interface State {
    botonRechazar: boolean;
    aprobacion: {
        estado: 'aprobado' | 'rechazado' | 'sin-supervision';
        motivo: string;
    };
    verificacion: EstadoVerificacion;
    error?: {
        mensaje: string;
        detalles: Array<string>;
    };
    matriculaState?: MatriculaState;
}

const stateInicial: State = {
    botonRechazar: false,
    aprobacion: {
        estado: 'sin-supervision',
        motivo: '',
    },
    verificacion: {
        tieneHuellas: false,
        tieneFotocopias: false,
        tieneFirmas: false,
        estado: 'pendiente',
    },
};

class ProcesoDeMatricula extends React.Component<Props, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = stateInicial;
    private readonly idMatricula = parseInt(this.props.match.params.id, 10);

    public componentDidMount() {
        this.obtenerMatricula();
    }

    public render() {
        const { matriculaState, error } = this.state;

        if (error) {
            return (
                <ModalError
                    mensaje={error.mensaje}
                    detalles={error.detalles}
                    alCerrar={() => this.setState({ error: undefined })}
                />
            );
        }

        if (!matriculaState) {
            return <Header as='h1'>Cargando...</Header>;
        }

        return (
            <Container>
                <PanelEstadoDeSupervision
                    aprobacion={this.state.aprobacion}
                    verificacion={this.state.verificacion}
                />
                <FormularioCompleto {...matriculaState} />
            </Container>
        );
    }

    private readonly obtenerMatricula = () => {
        clienteApi
            .ejecutar('procesoDeMatriculaDeId', this.idMatricula)
            .then(respuesta =>
                this.setState({
                    matriculaState: respuesta.state,
                    aprobacion: { motivo: '', ...respuesta.estadoAprobacion },
                    verificacion: respuesta.estadoVerificacion,
                }),
            )
            .catch(this.context.mostrarModalError);
    };
}

export default ProcesoDeMatricula;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/MisMatriculas/ProcesoDeMatricula/index.tsx